<template>
  <SmartLink
    class="action-link"
    :disabled="disabled"
    :active-class="activeClass"
    :exact-active-class="exactActiveClass"
    :url="url"
    :route="route"
    :target="target"
    :method="method"
    :event="event"
  >
    <slot></slot>
  </SmartLink>
</template>

<script>
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    activeClass: {
      type: String,
      default: 'router-link-active',
    },
    exactActiveClass: {
      type: String,
      default: 'router-link-exact-active',
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_blank',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
  },
  components: { SmartLink, },
};
</script>

<style scoped>
.action-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 6px 4px;

  &:hover {
    background-color: #D4D4D8;
    border-radius: 6px;
  }
}
</style>
